// extracted by mini-css-extract-plugin
module.exports = {"container":"nav__container","item":"nav__item","is-selected":"nav__is-selected","logoHolder":"nav__logoHolder"};